import { useContext } from 'react'

import { SchoolContext } from '../../../Providers/SchoolProvider'
import SearchList from '../../antd/Lists/SearchList'

const InstitutionsList = ({ bordered, selected, maxHeight, onSelectedChange }) => {
  const { unmanagedInstitutions } = useContext(SchoolContext)

  const institutionOptions = unmanagedInstitutions.map(institution => ({
    label: institution.name,
    value: institution.id,
    tooltip: institution.name
  }))

  return (
    <div className='h-100'>
      <SearchList
        selected={selected}
        data={institutionOptions}
        maxHeight={maxHeight}
        onSelectedChange={onSelectedChange}
      />
    </div>
  )
}

export default InstitutionsList
